module.exports = __webpack_public_path__ + "img/img-priority@2x.a8077185.png";